<template>
  <div class="doctor-skeleton">
    <div class="doctor-skeleton__top d-flex">
      <div class="d-flex flex-column flex-grow-0 mr-4">
        <v-skeleton-loader
          class="mb-2"
          height="160"
          width="120"
          type="image"
        />
        <v-skeleton-loader
          height="20"
          width="120"
          type="image"
        />
      </div>

      <div class="d-flex flex-column flex-grow-1">
        <v-skeleton-loader
          class="mb-2"
          type="text"
          width="84%"
        />
        <v-skeleton-loader
          class="mb-2"
          type="text"
          width="56%"
        />
        <v-skeleton-loader
          class="mb-4"
          type="text"
          width="76%"
        />
        <v-skeleton-loader
          class="mb-2"
          type="text"
          width="93%"
        />
        <v-skeleton-loader
          class="mb-2"
          type="text"
          width="93%"
        />
        <v-skeleton-loader
          class="mb-2"
          type="text"
          width="62%"
        />
      </div>
    </div>

    <v-skeleton-loader
      class="mb-6"
      height="48"
      type="image"
    />
    <v-skeleton-loader
      class="mb-6"
      height="75"
      width="210"
      type="image"
    />

    <div class="doctor-skeleton__day d-flex justify-center">
      <v-skeleton-loader
        class="d-flex mb-4"
        type="heading"
      />
    </div>

    <div class="doctor-skeleton__slots">
      <div class="d-flex">
        <v-skeleton-loader
          v-for="i in 4"
          :key="`skeleton-1-${i}`"
          class="ma-1 flex-grow-1"
          height="40"
          type="image"
        />
      </div>
      <div class="d-flex">
        <v-skeleton-loader
          v-for="i in 4"
          :key="`skeleton-2-${i}`"
          class="ma-1 flex-grow-1"
          height="40"
          type="image"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoctorCardSkeleton',
}
</script>

<style lang="scss">
.doctor-skeleton {
  .v-skeleton-loader__text {
    height: 16px;
    border-radius: 8px;
    margin: 0;
  }

  &__day .v-skeleton-loader__heading {
    width: 168px;
    height: 32px;
    border-radius: 16px;
  }

  &__slots .v-skeleton-loader__button {
    height: 40px;
  }
}
</style>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.doctor-skeleton {
  display: block;
  width: 100%;
  padding: 16px;
  background: $ui-kit-bg-gray-0;
  border: 1px solid $color-ultra-deep-grey;
  box-shadow: 0 15px 20px rgba(151, 158, 167, 0.1);
  border-radius: 10px;

  &__top {
    margin: 0 0 22px;
  }

  &__slots {
    margin: 0 -4px;
  }
}
</style>
